var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.18 1.5H5.82C3.75 1.5 3 2.25 3 4.3575V13.6425C3 15.75 3.75 16.5 5.82 16.5H12.1725C14.25 16.5 15 15.75 15 13.6425V4.3575C15 2.25 14.25 1.5 12.18 1.5Z",
    fill: "#161F28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.6875H7.5C7.1925 4.6875 6.9375 4.4325 6.9375 4.125C6.9375 3.8175 7.1925 3.5625 7.5 3.5625H10.5C10.8075 3.5625 11.0625 3.8175 11.0625 4.125C11.0625 4.4325 10.8075 4.6875 10.5 4.6875Z",
    fill: "#161F28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.4751C9.72487 14.4751 10.3125 13.8875 10.3125 13.1626C10.3125 12.4377 9.72487 11.8501 9 11.8501C8.27513 11.8501 7.6875 12.4377 7.6875 13.1626C7.6875 13.8875 8.27513 14.4751 9 14.4751Z",
    fill: "#161F28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.ee3dcf6ff233926a4d245036123c07f9.svg";
export { ForwardRef as ReactComponent };